<template>
  <div class="checkbox-view">
    <div class="checkbox-container">
      <input
        v-model="checked"
        class="checkbox"
        type="checkbox"
        :checked="localChecked === 'checked'"
        @change="change"
      />
      <span class="text">{{ $t('home-ad-popup-checkbox-public.dontShowToday') }}</span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'images',
  },
})

const localChecked = ref(window.localStorage.ImagesPopupChecked || 'null')
const localType = ref('')
const getLocalCheckedType = () => {
  switch (props.type) {
    case 'images':
      localChecked.value = window.localStorage.ImagesPopupChecked || 'null'
      localType.value = 'ImagesPopupChecked'
      break
    case 'atividade':
      localChecked.value = window.localStorage.AtividadePopupChecked || 'null'
      localType.value = 'AtividadePopupChecked'
      break
    case 'site-message':
      localChecked.value = window.localStorage.SiteMessagePopupChecked || 'null'
      localType.value = 'SiteMessagePopupChecked'
      break
    default:
      localChecked.value = window.localStorage.ImagesPopupChecked || 'null'
  }
}
getLocalCheckedType()

const checked = ref(false)
const change = () => {
  window.localStorage.setItem(localType.value, checked.value ? 'checked' : 'null')
  emit('change', checked.value)
}

const emit = defineEmits(['change'])
</script>

<style lang="scss" scoped>
.checkbox-view {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;

  .checkbox-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    background: #00000061;
    border-radius: 5px;

    .checkbox {
      width: 16px;
      height: 16px;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background: transparent;
      border: 1px solid var(--white);
      border-radius: 3px;
    }
    .checkbox:checked {
      appearance: auto;
      -webkit-appearance: auto;
      -moz-appearance: auto;
      background: transparent;
    }

    .text {
      margin-left: 5px;
      font-size: 11px;
      color: #fff;
    }
  }
}
</style>
